import { render, staticRenderFns } from "./Reviewsystem.vue?vue&type=template&id=7b00a66a"
import script from "./Reviewsystem.vue?vue&type=script&lang=js"
export * from "./Reviewsystem.vue?vue&type=script&lang=js"
import style0 from "./Reviewsystem.vue?vue&type=style&index=0&id=7b00a66a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports